import { CloseOutlined, ReloadOutlined } from "@ant-design/icons";
import { Divider, Drawer } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GetNotifcationsApi from "../api/notifications/GetNotificationsApi";
import MarkAllAsReadApi from "../api/notifications/MarkAllAsReadApi";
import OpenNotificationApi from "../api/notifications/OpenNotificationApi";
import { SimpleLoader } from "./sub/Loaders";

function Notifications(props) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const positionState = useSelector((state) => state.positionState.value);

  useEffect(() => {
    if (props.visible) {
      loadMoreData();
    }
  }, [props.visible]);

  // Refresh notifications when drawer opens
  useEffect(() => {
    if (props.visible && positionState?.id) {
      // Small delay to ensure the drawer is fully opened
      const timer = setTimeout(() => {
        loadMoreData();
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [props.visible, positionState?.id]);

  function handleClose() {
    props.onClose();
    setData([]);
  }

  async function loadMoreData(page) {
    setLoading(true);
    try {
      const apiResponse = await GetNotifcationsApi(
        1, // Always load page 1
        undefined, // No limit, fetch all notifications
        "", // Empty string means get all notifications (both read and unread)
        positionState.id
      );

      if (apiResponse.success) {
        // Set the data directly since we're not paginating
        setData(apiResponse.data?.notifications || []);
      } else {
        console.error('Failed to load notifications:', apiResponse);
        // Show error message to user
        setData([]);
      }
    } catch (error) {
      console.error('Error loading notifications:', error);
      // Show error message to user
      setData([]);
    } finally {
      setLoading(false);
    }
  }

  async function openNotification(id) {
    const apiResponse = await OpenNotificationApi(id);
    if (apiResponse.success) {
      handleClose();
      props.handleNotificationCount();
    }
  }
  async function markAllAsRead() {
    const apiResponse = await MarkAllAsReadApi(positionState?.id);
    if (apiResponse.success) {
      handleClose();
      props.handleNotificationCount();
    }
  }



  return (
    <Drawer closable={false} placement="right" visible={props.visible}>
      <div className="flex justify-between items-center">
        <div className="text-lg pri-font">Notifications</div>
        <div className="flex items-center gap-2">
          <ReloadOutlined 
            onClick={() => loadMoreData()} 
            className="cursor-pointer hover:text-blue-500"
            title="Refresh notifications"
          />
          <CloseOutlined onClick={() => handleClose()} />
        </div>
      </div>
      <Divider />
      <div className="flex justify-end ">
        <div
          className="cursor-pointer -mt-4 mb-2 text-gray-500 hover:text-black"
          onClick={() => markAllAsRead()}
        >
          Mark all as read
        </div>
      </div>

      <>
        {data.map((item) => (
          <Link
            to={item.notification?.url}
            className={
              "border p-2 mb-2 rounded-sm block " +
              (item.status === "UnRead" ? "bg-gray-100" : "bg-white")
            }
            onClick={() => {
              handleClose();
              openNotification(item.id);
            }}
          >
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <div>{moment(item?.notification?.createdOn).format("DD.MM.YYYY")}</div>
              <div> {moment(item?.notification?.createdOn).format("HH:mm:ss a")}</div>
            </div>
            <div className="text-black mt-1">{item?.notification?.message}</div>
          </Link>
        ))}
        {loading ? (
          <SimpleLoader />
        ) : data.length === 0 ? (
          <div className="text-center text-gray-500">
            No notifications available.
          </div>
        ) : null}
      </>
    </Drawer>
  );
}

export default Notifications;
